import { WorkLocation } from '@/javascript/domain/entities/maps/work-location'
import { RemoteWorkLocation } from '@/javascript/data/entities/maps/remote-work-location'
import { ListMapper } from './mapper'

export class WorkLocationMapper extends ListMapper<WorkLocation, RemoteWorkLocation> {
  toEntity (data: RemoteWorkLocation): WorkLocation {
    return {
      id: data.work_id,
      description: data.title,
      status: data.status as 'not_started' | 'started' | 'finished' | 'reviewed',
      startTime: data.start_time,
      latitude: data.latitude ? parseFloat(data.latitude) : undefined,
      longitude: data.longitude ? parseFloat(data.longitude) : undefined,
      accountId: data.account_id,
      resourcePlaceId: data.resource_place_id,
      resourcePlaceName: data.resource_place_name,
      hierarchyName: data.hierarchy_name,
      isLate: data.is_late
    }
  }
}
